// extracted by mini-css-extract-plugin
module.exports = {"liveIndicator":"LiveIndicator_liveIndicator__0YBaH","liveIndicator--disabled":"LiveIndicator_liveIndicator--disabled__sEdkP"};